// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3QCAS","text":"SelectPayment_text__5jseA","title":"SelectPayment_title__28tZU","btn":"SelectPayment_btn__3nnrj"};